/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { getNodeMessage } from '../../helpers/timeline';

const Node = ({ isBoxNode, isMobile, data: { message, date, status, link } }) => {
  return (isBoxNode ? (
    <div className={cx({ 'challenge-timeline__node': isMobile, 'challenge-timeline__node-desktop': !isMobile })}>
      <div className={cx('timeline__node__point', status)} />
      <div className={isMobile ? 'challenge-timeline__node__label' : 'challenge-timeline__node__label-desktop'}>
        {message}
      </div>
    </div>
  ) : (
      <div className="timeline__node">
        <div className={cx('timeline__node__point', status)} />
        {link && (
          <a className="timeline__node__label" href={link}>
            {message}
          </a>
        )}
        {!link && (
          <div className="timeline__node__label">
            {getNodeMessage(message, date)}
          </div>
        )}
      </div>
    ));
};

Node.defaultProps = {
  data: [],
  isBoxNode: false,
  isMobile: true,
};

Node.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.string,
    order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    date: PropTypes.string,
    group: PropTypes.string,
    link: PropTypes.string,
  }),
  isBoxNode: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default Node;
